// extracted by mini-css-extract-plugin
module.exports = {"language-switcher":"LanguageSwitcher_language-switcher__3y1_i","is-active":"LanguageSwitcher_is-active__p3MVU"};